import React from 'react';
import { Image } from 'frontend/types';
import styles from './Closed.module.css';
import ToggleButton from '../ToggleButton/ToggleButton';
import NextImage from 'components/NextImage/NextImage';
interface ClosedProps {
  educationLevels: string;
  images: Image;
  schoolSubjects?: string;
  title: string;
  toggle: () => void;
  usp: string;
  isSeriesPage: boolean;
}
const Closed = ({
  educationLevels,
  images,
  schoolSubjects,
  title,
  toggle,
  usp,
  isSeriesPage
}: ClosedProps, ref: React.Ref<HTMLButtonElement>) => {
  return <div className={styles.seriesBannerHeader} data-sentry-component="Closed" data-sentry-source-file="Closed.tsx">
      <figure className={styles.imageWrapper}>
        <NextImage width={194} height={109} alt="series" className={styles.image} src={images['320x180']} shadow roundedCorners data-sentry-element="NextImage" data-sentry-source-file="Closed.tsx" />
      </figure>

      <div className={styles.metadataWrapper}>
        {isSeriesPage ? <h1 className={styles.seriesTitle}>{title}</h1> : <h2 className={styles.seriesTitle}>{title}</h2>}
        <p className={styles.usp}>{usp}</p>
        {educationLevels && <p className={styles.metadataValues}>{`• ${educationLevels}`}</p>}
        {schoolSubjects && <p className={styles.metadataValues}>{`• ${schoolSubjects}`}</p>}
      </div>
      <ToggleButton isOpen={false} ref={ref} toggle={toggle} data-sentry-element="ToggleButton" data-sentry-source-file="Closed.tsx" />
    </div>;
};
export default React.forwardRef(Closed);